import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import apptrackService from "utils/apptrack.service";
// import { getErrorMessageClaim, getErrorMessageEdit } from "../util/helper";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as CheckIcon } from '../../../../../../assets/icons/check_purple_icon.svg'
import { useNavigate } from "react-router-dom";
import { claimActive, updateFormField } from "store/forms/actions";
import { getLocalString, localNames } from "utils/localisation.service";
import { isBeneficiary } from "utils";

const ActionList = (props) =>{
    return(
        <div className="popover-container">
            { <div className="popover-item" onClick={()=>{props.setEditOpen(true); props.open(false)}}>Edit<CheckIcon className="check"/></div> }
            {/* { <div className="popover-item" onClick={()=>{props.setDeleteOpen(true); props.open(false)}}>Delete<CheckIcon className="check"/></div> } */}
        </div>
    )
}

export default ActionList;